import { styled } from '@mui/material';

export const Styles = {
  Main: styled('div')(({ theme }) => ({
    backgroundColor: '#ebebeb',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3, 0),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2, 0)
    }
  })),
  Container: styled('div')(({ theme }) => ({
    maxWidth: '1200px',
    width: '100%',
    margin: '0 auto',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
      borderRadius: '8px'
    }
  })),

  LabelTipo: styled('div')(({ theme }) => ({
    fontWeight: 700,
    fontSize: '18px',
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    lineHeight: '24px',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(0, 2),
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      textAlign: 'center'
    }
  })),

  Label: styled('label')(({ theme }) => ({
    fontWeight: 400,
    fontSize: '17px',
    lineHeight: '27px',
    color: 'black',
    '&.required::after': {
      content: '" *"',
      color: theme.palette.error.main,
      marginLeft: theme.spacing(0.5)
    }
  })),
  SectionTitle: styled('h2')(({ theme }) => ({
    color: '#04682E',
    fontSize: '20px',
    // paddingBottom: theme.spacing(1),
    width: '100%'
    // margin: theme.spacing(2, 0, 2, 0)
  })),

  FormRow: styled('div')({
    display: 'flex',
    gap: '20px',
    marginBottom: '20px',
    flexWrap: 'wrap'
  }),
  CheckboxLabel: styled('label')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    fontSize: '16px',
    cursor: 'pointer'
  })),
  InputContainer: styled('div')<{ fullWidth?: boolean; width?: string }>(
    ({ fullWidth, width, theme }) => ({
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      flex: fullWidth ? '0 0 100%' : width ? `0 0 ${width}` : '1',
      [theme.breakpoints.down('md')]: {
        flex: '0 0 100%'
      }
    })
  ),

  Input: styled('input')(({ theme }) => ({
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #000000',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    },
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E'
    }
  })),

  Select: styled('select')({
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #000000',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    backgroundColor: 'white',
    appearance: 'none',
    backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 1rem center',
    backgroundSize: '1em',
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E'
    }
  }),

  Button: styled('button')(({ theme }) => ({
    width: '150px',
    marginLeft: '5px',
    padding: '10px 30px',
    fontSize: '16px',
    backgroundColor: '#125dae',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginLeft: '0',
      fontSize: '14px'
    },
    '&:hover': {
      backgroundColor: '#0B327A'
    }
  })),

  TextArea: styled('textarea')({
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #000000',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    minHeight: '100px',
    resize: 'vertical',
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E'
    }
  })
};
